/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Svc_Mcp_Server_Development_Work_0_Metric_2_LabelInputs */

const en_svc_mcp_server_development_work_0_metric_2_label = /** @type {(inputs: Svc_Mcp_Server_Development_Work_0_Metric_2_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Uncaught loops`)
};

const ar_svc_mcp_server_development_work_0_metric_2_label = /** @type {(inputs: Svc_Mcp_Server_Development_Work_0_Metric_2_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`حلقات غير مكتشفة`)
};

const bn_svc_mcp_server_development_work_0_metric_2_label = /** @type {(inputs: Svc_Mcp_Server_Development_Work_0_Metric_2_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`বাধাহীন লুপ`)
};

const de_svc_mcp_server_development_work_0_metric_2_label = /** @type {(inputs: Svc_Mcp_Server_Development_Work_0_Metric_2_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nicht abgefangene Schleifen`)
};

const es_svc_mcp_server_development_work_0_metric_2_label = /** @type {(inputs: Svc_Mcp_Server_Development_Work_0_Metric_2_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Bucles no capturados`)
};

const fr_svc_mcp_server_development_work_0_metric_2_label = /** @type {(inputs: Svc_Mcp_Server_Development_Work_0_Metric_2_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Boucles non capturées`)
};

const pt_svc_mcp_server_development_work_0_metric_2_label = /** @type {(inputs: Svc_Mcp_Server_Development_Work_0_Metric_2_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Loops não capturados`)
};

const zh_svc_mcp_server_development_work_0_metric_2_label = /** @type {(inputs: Svc_Mcp_Server_Development_Work_0_Metric_2_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`未捕获的循环`)
};

const tr_svc_mcp_server_development_work_0_metric_2_label = /** @type {(inputs: Svc_Mcp_Server_Development_Work_0_Metric_2_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Yakalanmayan döngüler`)
};

const ru_svc_mcp_server_development_work_0_metric_2_label = /** @type {(inputs: Svc_Mcp_Server_Development_Work_0_Metric_2_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Неперехваченные петли`)
};

const pl_svc_mcp_server_development_work_0_metric_2_label = /** @type {(inputs: Svc_Mcp_Server_Development_Work_0_Metric_2_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nieprzechwycone pętle`)
};

/**
* | output |
* | --- |
* | "Uncaught loops" |
*
* @param {Svc_Mcp_Server_Development_Work_0_Metric_2_LabelInputs} inputs
* @param {{ locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }} options
* @returns {LocalizedString}
*/
const svc_mcp_server_development_work_0_metric_2_label = /** @type {((inputs?: Svc_Mcp_Server_Development_Work_0_Metric_2_LabelInputs, options?: { locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Svc_Mcp_Server_Development_Work_0_Metric_2_LabelInputs, { locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "ar") return ar_svc_mcp_server_development_work_0_metric_2_label(inputs)
	if (locale === "bn") return bn_svc_mcp_server_development_work_0_metric_2_label(inputs)
	if (locale === "de") return de_svc_mcp_server_development_work_0_metric_2_label(inputs)
	if (locale === "es") return es_svc_mcp_server_development_work_0_metric_2_label(inputs)
	if (locale === "fr") return fr_svc_mcp_server_development_work_0_metric_2_label(inputs)
	if (locale === "pt") return pt_svc_mcp_server_development_work_0_metric_2_label(inputs)
	if (locale === "zh") return zh_svc_mcp_server_development_work_0_metric_2_label(inputs)
	if (locale === "tr") return tr_svc_mcp_server_development_work_0_metric_2_label(inputs)
	if (locale === "ru") return ru_svc_mcp_server_development_work_0_metric_2_label(inputs)
	if (locale === "pl") return pl_svc_mcp_server_development_work_0_metric_2_label(inputs)
	return en_svc_mcp_server_development_work_0_metric_2_label(inputs)
});
export { svc_mcp_server_development_work_0_metric_2_label as "svc_mcp-server-development_work_0_metric_2_label" }